module.exports = __webpack_public_path__ + "31e9a69203b7e4d5b87642704b3c06e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/vanguard.png
// module id = 1878
// module chunks = 0